<template>
  <div class="">
    <v-card>
        <v-container py-3 fluid>
          <v-layout row justify-space-between>
              <div class="d-flex align-center">
                <v-chip color="primary" text-color="white">Active</v-chip>
              </div>
              <div class="d-flex justify-end align-center">
                <!--
                  Disabled because down server
                -->
                <v-btn slot="activato" icon fat v-if="survey.type === 'devices'" @click="openGeolocation(survey.id)">
                    <v-icon color ="prmary">my_location</v-icon>
                </v-btn>
                
                <v-menu bottom left v-if="!showcomponentManager">
                    <v-btn slot="activator" icon flat>
                      <v-icon color ="prmary">more_vert</v-icon>
                    </v-btn>
                    <v-list>
          
                      
                      <v-list-tile @click="$emit('edit-survey', {index, survey})">
                        <v-list-tile-avatar>
                            <v-icon color="primary">edit</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="'Edit'"></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-divider light></v-divider>
                      
                      <v-list-tile @click="$emit('duplicate-survey', {index, survey})">
                        <v-list-tile-avatar>
                          <v-icon color="primary">file_copy</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="'Duplicate'"></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-divider light></v-divider>
                      
                      <v-list-tile @click="$emit('delete-survey', {index, survey})">
                        <v-list-tile-avatar>
                            <v-icon color="red">delete</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="'Delete'"></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    
                    </v-list>
                </v-menu>
              </div>
          </v-layout>
        </v-container>
        <v-divider light></v-divider>
        <v-card-title>
        <v-card-text class="text-center pb-0">
            <h5 class="title mb-3">{{ survey.title }}</h5>
            <p class="subheading mb-2"><strong>Created by {{ survey.owner_name }}</strong></p>
        </v-card-text>
        </v-card-title>
        <div class="d-flex">
        <v-flex xs12 pt-0>
            <v-card-text class="text-center pt-0">
            <p>
                <strong>{{ survey.total_rounds }}</strong>
                <br>Round(s)
                <br>
                <span v-if="survey.type === 'mailing' || survey.type === 'custom' ">
                  <v-chip>
                      <v-avatar class="info"><v-icon class="icons-pills">contact_mail</v-icon></v-avatar>
                      Mailing
                  </v-chip>
                </span>
                <span v-if="survey.type === 'devices'">
                  <v-chip>
                      <v-avatar class="info"><v-icon class="icons-pills">devices</v-icon></v-avatar>
                      Devices
                  </v-chip>
                </span>
                <span v-if="survey.type === 'labor'">
                  <v-chip>
                      <v-avatar class="info"><v-icon class="icons-pills">business</v-icon></v-avatar>
                      Labor Climate
                  </v-chip>        
                </span>
            </p>
            <p>Created at {{ survey.created_at }}</p>
            </v-card-text>
        </v-flex>
        </div>
        <div class="wrapper-btn-center">
        <v-btn icon color="info" large :to="{ name: 'SurveyShow', params: { survey_id: survey.id } }" @click="$emit('selectsurvey', survey)">
            <v-icon>remove_red_eye</v-icon>
        </v-btn>

        </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    survey: Object,
    index: Number
  },
  computed: {
    ...mapGetters(['currentUser']),
    showcomponentManager: function () {
      if (this.currentUser.role === 'manager') {
        return true;
      }
      return false;
    },
  },
  methods: {
    openGeolocation (survey_id) {
      let routeData = this.$router.resolve({ name: 'Geolocation', params: { survey_id: survey_id }});
      window.open(routeData.href, '_blank');
    }
  }

};
</script>

<style>
.wrapper-btn-center {
  position: relative;
  margin-left: 43%;
}


</style>


// WEBPACK FOOTER //
// src/components/client/surveys/components/CardSurvey.vue